const PROVIDER_CONFIG = {
  '9bb58a76-89cc-4085-98ad-f14b6fe90a38': {
    name: 'Dr. Kantha',
    type: 'phone',
    phone: '201-445-7744',
  },
  '733ed709-6536-4d8c-b8c3-fab6fcadd4c8': {
    name: 'Dr. Miller',
    type: 'doxy',
    doxyUrl: 'https://drjcmiller.doxy.me/mmj',
  },
  '4b8dc115-7099-41b6-a052-76d9daadd936': {
    name: 'Dr. Patel',
    type: 'doxy',
    doxyUrl: 'https://drjcmiller.doxy.me/patelmmj',
  },
  'caf29308-a980-4796-a447-6b3bdbe32928': {
    name: 'Dr. Okonkwo',
    type: 'doxy',
    doxyUrl: 'https://drjcmiller.doxy.me/okonkwommj',
  },
};

export default PROVIDER_CONFIG;
